import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import type { FormOptionType } from "@/components/ui/form/_types/type";
import { RadioGroupField } from "@/components/ui/form/fields/radio-field/radio-group";

import type { SnackBlocksFormModelMethodsType } from "../../../../../model/usecase/use-create-snack-layout-settings-form-model/methods";

type Props = {
	languageSwitcherMethods: SnackBlocksFormModelMethodsType["languageSwitcherMethods"];
};

export const IslandLayoutSettingsLanguageSwitcher = ({ languageSwitcherMethods }: Props) => {
	const options = [
		{ id: "lang-switch-on", label: "表示する", value: "true" } satisfies FormOptionType,
		{ id: "lang-switch-off", label: "表示しない", value: "false" } satisfies FormOptionType,
	] satisfies FormOptionType[];

	return (
		<QuestionForMain
			required={false}
			title="言語切替の表示設定"
			guide="ページのヘッダーにある「日本語/English」切替ボタンの表示を設定します。"
			inputChildren={
				<div className="space-y-8">
					<RadioGroupField
						value={String(languageSwitcherMethods.isShowLanguageSwitcher)}
						options={options}
						handleValueChange={languageSwitcherMethods.handleChangeIsShowLanguageSwitcher}
					/>
				</div>
			}
		/>
	);
};

IslandLayoutSettingsLanguageSwitcher.displayName = "IslandLayoutSettingsLanguageSwitcher";
